<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { field } from 'svelte-forms';
	import { getTranslate } from '@tolgee/svelte';

	import InputWithLabel from '$lib/components/Form/Input/InputWithLabel.svelte';
	import { customForm } from '$lib/types/form';
	import Button from '../Button/Button.svelte';
	import { classes } from '$lib/utils';

	import { required } from 'svelte-forms/validators';
	import { requestForgotPassword } from '$lib/service/supabase/user.service';

	const { t } = getTranslate();
	const dispatch = createEventDispatcher();

	export let additionalClass = '';

	let loading = false;

	const email = field('email', '', [required()]);
	const forgotPasswordForm = customForm(email);
	let serverError: string = '';

	const handleSubmit = async () => {
		loading = true;
		await forgotPasswordForm.internalForm.validate();

		if (!$forgotPasswordForm.valid) {
			return;
		}
		await requestForgotPassword($email.value);
		loading = false;
	};
</script>

<div class={classes(additionalClass, 'flex flex-col items-center justify-center')}>
	<h1 class="mb-6 text-xl font-semibold w-full">{@html $t('ForgotPasswordForm.headline')}</h1>
	<div class="w-full"><p class="mb-6  w-96">{@html $t('ForgotPasswordForm.paragraph')}</p></div>

	<form
		class="space-y-4 lg:space-y-6 w-full flex flex-col justify-center"
		on:submit|preventDefault={handleSubmit}
	>
		<InputWithLabel
			type="email"
			id="email"
			placeholder="E-Mail"
			bind:value={$email.value}
			errorClass="border-error"
			errorMessage={$t('form_emailRequiredErrorMessage')}
			hasError={$forgotPasswordForm.hasError('email.required') ||
				($forgotPasswordForm.hasError('email.match_field') &&
					!$forgotPasswordForm.hasError('email.required'))}
		/>

		{#if serverError}
			<div class="text-error">{serverError}</div>
		{/if}

		<div class="text-center">
			<Button additionalClass="mt-4" type="submit">
				{$t('ForgotPasswordForm.button')}</Button
			>
			<p class="text-sm font-light mt-4">
				<a href="/auth/login" class="font-medium hover:underline text-purple"
					>{@html $t('ForgotPasswordForm.return_to_login')}</a
				>
			</p>
		</div>
	</form>
</div>
